<template>
  <div>
    <v-layout wrap pt-16 justify-center>
      <v-flex xs11 text-left pt-16>
        <span
          style="color: #1f1f1f; font-family: poppinssemibold; font-size: 20px"
        >
          Privacy Policy</span
        >
      </v-flex>
      <v-flex xs11 sm11 md11 lg11 xl11 pt-5 pb-16 text-justify>
        <span
          style="font-family: poppinsregular; font-size: 15px; color: #1a1919"
        >
          <!-- v-html="pageData.details" -->
          At Eco Shop Kerala, we value your privacy and are committed to
          protecting your personal information. This Privacy Policy outlines how
          we collect, use, and safeguard your information when you visit our
          website and use our services.
          <br /> <br />
          <b>1. Information We Collect</b> <br />  <br> We may collect the following types of
          information when you visit our website or make a purchase: Personal
          Information: This includes your name, email address, phone number,
          shipping address, and payment information. Non-Personal Information:
          We may collect information about your usage of our website, including
          your IP address, browser type, and pages visited.
          <br />
          <br>
          <b>2. How We Use Your Information</b> <br />  <br> We use the information we collect for
          various purposes, including: Processing and fulfilling your orders.
          Communicating with you about your orders and inquiries. Improving our
          website and services. Sending you promotional materials, newsletters,
          and other information that may interest you (you can opt out at any
          time).
          <br />
          <br>
          <b>3. Cookies Our website uses cookies to enhance your experience.</b>
          <br>
          <br>
          Cookies are small files that are placed on your device to collect
          information about your activity on our site. You can choose to accept
          or decline cookies. Most web browsers automatically accept cookies,
          but you can usually modify your browser setting to decline cookies if
          you prefer.
          <br />
          <br>
          <b>4. Data Sharing and Disclosure</b> <br>  <br> We do not sell, trade, or otherwise
          transfer your personal information to outside parties without your
          consent, except to provide services to you or as required by law. We
          may share your information with: Service providers who assist us in
          operating our website and conducting our business (e.g., payment
          processors, shipping companies). Legal authorities if required to
          comply with applicable laws.
          <br />
          <br>
          <b>5. Data Security</b> <br>  <br>We implement appropriate technical and organizational
          measures to protect your personal information from unauthorized
          access, loss, or misuse. However, no method of transmission over the
          internet or method of electronic storage is 100% secure, and we cannot
          guarantee its absolute security.
        </span>
      </v-flex>
    </v-layout>
  </div>
</template>
    <script>
import axios from "axios";
export default {
  data() {
    return {
      pageData: {},
    };
  },
  beforeMount() {
    // this.getData();
  },
  methods: {
    getData() {
      axios({
        method: "GET",
        url: "/privacyPoicy",
        // params: {
        //   Name: "Terms and Conditions",
        // },
      })
        .then((response) => {
          this.pageData = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>